import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { orderBy } from 'lodash';

@Component({
  selector: 'seb-reports-box',
  templateUrl: './reports-box.component.html',
  styleUrls: ['./reports-box.component.css']
})
export class ReportsBoxComponent implements OnInit {
  @Input() title: string;
  @Input() value: number;
  @Input() isSelectVisible: Boolean;
  @Input() selectItems: [{ label: ''; value: '' }];
  @Input() selectBindLabel: string;
  @Input() selectBindLabelProfile: string;
  @Input() tooltipText: string;
  @Input() selectedItem: any;
  @Input() selectedProfile = 1;
  @Input() reportsBoxHeight: string;
  @Input() loading: Boolean;
  @Input() description: string;
  @Input() selectProfiles: Array<any>;
  @Input() isDigitalUsages = false;
  @Input() isUserPerApps = false;
  @Input() updateDate: any;

  @Output() selectChange = new EventEmitter();
  @Output() selectProfile = new EventEmitter();

  constructor() { }

  ngOnInit() {}

  selectOnChange(item: any): void {
    this.selectChange.emit(item);
  }

  onSelectProfile(item: any) {
    this.selectProfile.emit(item);
  }

  getValue(): String {
    return Intl.NumberFormat('pt-BR').format(this.value);
  }

}
